import { heroStats } from '@/mocks/homeData';

export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/80 via-background-50 to-background-100/40"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 pt-24 md:pt-28 pb-12 md:pb-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-primary-600 bg-primary-50 px-4 py-1.5 rounded-full mb-5">
              <i className="ri-fire-line"></i>
              <span>全网热门免费看片平台</span>
            </p>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-4">
              91免费<span className="text-primary-500">·</span>您的免费看片大全
            </h1>

            <p className="text-base md:text-lg text-foreground-600 mb-5 max-w-2xl mx-auto lg:mx-0 font-heading leading-relaxed">
              告别付费，回归纯粹观影体验
            </p>

            <div className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7 space-y-2">
              <p>
                91免费看片网站汇聚海量高清影视资源，覆盖电影、电视剧、综艺、动漫、纪录片等
                <strong className="text-foreground-800">30余个内容分类</strong>，
                每日<strong className="text-foreground-800">新增超200部</strong>精选内容。
              </p>
              <p>
                无论您想追最新热播剧、回顾经典老片，还是探索小众佳作，
                91免费看片神器都能为您提供<strong className="text-foreground-800">流畅高清</strong>的观影体验。
                全终端适配，打开浏览器即看，真正实现看片自由。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="text-xl md:text-2xl font-bold text-primary-500 font-heading">{stat.value}</p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => handleNavClick(e, '#carousel')}
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-7 py-3 rounded-md font-semibold text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始免费看片
              </a>
              <a
                href="#features"
                onClick={(e) => handleNavClick(e, '#features')}
                className="inline-flex items-center gap-2 bg-secondary-100 hover:bg-secondary-200 text-foreground-800 px-7 py-3 rounded-md font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                了解平台优势
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] lg:aspect-[5/4] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20warm%20ambient%20red%20and%20gold%20lighting%2C%20velvet%20seats%2C%20large%20projection%20screen%20displaying%20abstract%20film%20reel%20patterns%2C%20elegant%20art%20deco%20architectural%20details%2C%20rich%20warm%20color%20palette%20with%20deep%20crimson%20and%20gold%20tones%2C%20atmospheric%20mood%20lighting%2C%20professional%20interior%20photography%20style%2C%20clean%20composition%2C%20no%20people%20visible&width=800&height=600&seq=hero-main-01&orientation=squarish"
                alt="91免费看片平台影院级观影体验"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}